module.exports = __webpack_public_path__ + "static/media/Chris Rohde.402fc5f3.png";